import React, { useEffect, useState } from 'react'
import { Dialog, Stack, Text, Accordion, Separator } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'
import { SecondaryButton } from '@!/components/Button'
import { SearchFilterItem } from '@!/Store/SearchList/components/SearchFilterItem'

export const SearchFilterModal = ({ isOpen, onClose, title, type, keyword, genreTabName, genreMap, onSearch }) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  const genres = [
    { label: '少年マンガ', value: 'boy' },
    { label: '青年マンガ', value: 'man' },
    { label: '少女マンガ', value: 'girl' },
    { label: '女性マンガ', value: 'lady' },
    ...(safeSearch
      ? []
      : [
          { label: 'ボーイズラブマンガ', value: 'bl' },
          { label: 'ティーンズラブマンガ', value: 'tl' },
        ]),
  ]

  const subGenres = [
    '異世界',
    '実写化・アニメ化・ノベライズ',
    'スポーツ',
    'バトル・格闘・アクション',
    'SF',
    'ファンタジー・幻想',
    'ギャグ・コメディ',
    'サスペンス',
    '怪奇・ホラー',
    'ヤンキー・極道',
    '推理・ミステリー',
    'レディースコミック',
    'アンソロジー・短編集',
    '耽美・恋愛',
    'ヒューマンドラマ',
    '学園',
    'ラブコメ',
    'ラブストーリー',
    '動物・ペット・植物',
    'エッセイ・日常・ほのぼの',
    'ガールズラブ',
    'コミック雑誌',
  ].map((label) => ({ label, value: label }))

  const deals = ['無料あり', '割引あり'].map((label) => ({ label, value: label }))

  const publicationStatus = ['新刊', '完結'].map((label) => ({ label, value: label }))

  const [selectedGenres, setSelectedGenres] = useState([])
  const [selectedSubGenres, setSelectedSubGenres] = useState([])
  const [selectedDeals, setSelectedDeals] = useState([])
  const [selectedPublicationStatus, setSelectedPublicationStatus] = useState([])

  useEffect(() => {
    if (!genreTabName) return

    setSelectedGenres(genreMap[genreTabName] || [])
  }, [genreTabName, genreMap])

  useEffect(() => {
    if (type === 'category') {
      setSelectedSubGenres([keyword])
    }
  }, [type])

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch({
        selectedGenres,
        selectedSubGenres,
        selectedDeals,
        selectedPublicationStatus,
      })
    }
    onClose()
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={(details) => !details.open && onClose()} size="sm" placement="center">
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header textAlign="center" fontWeight="bold" fontSize="md">
            絞り込み検索
          </Dialog.Header>

          <Dialog.CloseTrigger />

          <Dialog.Body px={4} pt={0} pb={6}>
            <Stack gap={2} fontSize="xs" px={2} py={4}>
              <Text fontWeight="semibold">{title}</Text>
              <Text>「{keyword}」</Text>
            </Stack>
            <Separator />
            <Accordion.Root collapsible w="100%">
              <Stack gap={0} separator={<Separator w="100%" />}>
                <SearchFilterItem
                  title="ジャンル"
                  options={genres}
                  selectedItems={selectedGenres}
                  onChange={setSelectedGenres}
                  disabled={Boolean(genreTabName)}
                  value="genre"
                />
                <SearchFilterItem
                  title="サブジャンル"
                  options={subGenres}
                  selectedItems={selectedSubGenres}
                  onChange={setSelectedSubGenres}
                  disabled={type === 'category'}
                  value="sub-genre"
                />
                <SearchFilterItem title="お得" options={deals} selectedItems={selectedDeals} onChange={setSelectedDeals} value="deals" />
                <SearchFilterItem
                  title="刊行情報"
                  options={publicationStatus}
                  selectedItems={selectedPublicationStatus}
                  onChange={setSelectedPublicationStatus}
                  value="publication-status"
                />
              </Stack>
              <Separator />
            </Accordion.Root>
          </Dialog.Body>

          <Dialog.Footer p={0}>
            <SecondaryButton w="100%" height="53px" onClick={handleSearchClick}>
              この条件で検索
            </SecondaryButton>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  )
}
